module.exports = __webpack_public_path__ + "static/alchemy_jug-a832654d7f5d0783747d3bf1e2a618a9.jpeg";